import { Module } from "vuex";
import { IAuthState } from "./interface";
import { IStoreRootState } from "@/store/interface";
import state from './state';
import getters from "./getters";
import mutations from "./mutations";

export const AUTH_MODULE_NAME: string = 'auth';

export default <Module<IAuthState, IStoreRootState>> {
	namespaced: true,
	state,
	getters,
	mutations
}
